export const START_REPEATORDER_TO_ORDERPAD = "START_REPEATORDER_TO_ORDERPAD";
export const SUCCESS_REPEATORDER_TO_ORDERPAD =
  "SUCCESS_REPEATORDER_TO_ORDERPAD";
export const ERROR_REPEATORDER_TO_ORDERPAD = "ERROR_REPEATORDER_TO_ORDERPAD";

export const START_CREATE_ORDER_PAD = "START_CREATE_ORDER_PAD";
export const SUCCESS_CREATE_ORDERPAD = "SUCCESS_CREATE_ORDERPAD";
export const ERROR_CREATE_ORDERPAD = "ERROR_CREATE_ORDERPAD";

export const START_CREATE_TODAY_ORDER_PAD = "START_CREATE_TODAY_ORDER_PAD";
export const SUCCESS_CREATE_TODAY_ORDERPAD = "SUCCESS_CREATE_TODAY_ORDERPAD";
export const ERROR_CREATE_TODAY_ORDERPAD = "ERROR_CREATE_TODAY_ORDERPAD";

export const RESET_ORDER_PAD_STATE = "RESET_ORDER_PAD_STATE";

export const START_ORDER_SPEED = "START_ORDER_SPEED";
export const SUCCESS_ORDER_SPEED = "SUCCESS_ORDER_SPEED";
export const ERROR_ORDER_SPEED = "ERROR_ORDER_SPEED";
